/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	Component
} from '@angular/core';

@Component({
	selector: 'app-insurance',
	templateUrl: './insurance.component.html'
})

/**
 * A component representing an instance of the main
 * insurance page.
 *
 * @export
 * @class InsuranceComponent
 */
export class InsuranceComponent
{
}